import React from 'react';
import { FlexContainer, Heading, TextField, Link as LinkComponent, FlexRow, FlexColumn, Text } from '@forecast-it/design-system';
import { SageLogo } from '../../images/SageLogo';
import { Content, LogoWrapper, Page, PageContent, WideButton } from './Sage.styled';
import { Link as RouterLink } from 'react-router-dom';
export const SageForgotPassword = ({ errorMessage, email, onEmailChange, onReset, isSent, }) => {
    return (React.createElement(Page, null,
        React.createElement(Content, { alignItems: "center", justifyContent: "center" },
            React.createElement(LogoWrapper, null,
                React.createElement(SageLogo, { size: "160" })),
            React.createElement(FlexContainer, null,
                React.createElement(PageContent, { gap: "xl" }, isSent ? (React.createElement(React.Fragment, null,
                    React.createElement(FlexColumn, { gap: "l" },
                        React.createElement(Heading, { size: "3" }, "Check Your Email"),
                        React.createElement(Text, null,
                            "We sent a password reset link to ",
                            React.createElement("b", null, email),
                            React.createElement("br", null),
                            "If you don't get the email soon, check your spam folder.")),
                    React.createElement(FlexRow, { alignItems: "center", justifyContent: "center" },
                        React.createElement(RouterLink, { to: "/", component: LinkComponent }, "Return to Sign in")))) : (React.createElement(React.Fragment, null,
                    React.createElement(FlexColumn, { gap: "l" },
                        React.createElement(Heading, { size: "3" }, "Reset Your Password"),
                        React.createElement(TextField, { label: "Email", autoComplete: "email", errorText: errorMessage, value: email, onValueChange: onEmailChange })),
                    React.createElement(WideButton, { onClick: onReset }, "Reset Password"),
                    React.createElement(FlexRow, { alignItems: "center", justifyContent: "center" },
                        React.createElement(RouterLink, { to: "/", component: LinkComponent }, "Return to Sign in")))))))));
};
